import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";

const MINUTES_UNTIL_AUTO_LOGOUT = 20;
const CHECK_INTERVAL = 5000;
const STORE_KEY = "lastAction";

@Injectable({
  providedIn: "root",
})
export class AutoLogoutService {
  private excludedRoutes: string[] = [
    "/isf-school",
    "/student-certificate",
    "/certificate-dashboard",
    "/parent-dashboard",
    "/school-registration",
    "/student-registration",
    "/login",
  ];

  public getLastAction(): number {
    return parseInt(localStorage.getItem(STORE_KEY), 10);
  }

  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  constructor(private router: Router) {
    this.setLastAction(Date.now());
    this.initListener();
    this.initInterval();
  }

  private isExcludedRoute(route: string): boolean {
    return this.excludedRoutes.some((excluded) => route.startsWith(excluded));
  }

  initListener() {
    document.body.addEventListener("click", () => this.reset());
    document.body.addEventListener("mousemove", () => this.reset());
    document.body.addEventListener("keydown", () => this.reset());
    document.body.addEventListener("keyup", () => this.reset());
    document.body.addEventListener("keypress", () => this.reset());
    window.addEventListener("storage", () => this.storageEvt());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNTIL_AUTO_LOGOUT * 60 * 1000;
    const isTimeout = timeleft - now < 0;
    const currentRoute = this.router.url;

    if (isTimeout && !this.isExcludedRoute(currentRoute)) {
      localStorage.removeItem("currentUser");
      localStorage.removeItem("roleId");
      localStorage.removeItem("isAffiliate");
      localStorage.removeItem("schoolId");
      localStorage.removeItem("schoolName");
      localStorage.removeItem("isVoulnteer");
      localStorage.removeItem("schoolZone");
      localStorage.removeItem("dateDiff");
      localStorage.removeItem("eventId");
      localStorage.removeItem("eventYear");
      localStorage.removeItem(STORE_KEY);
      // Clear JWT tokens from AuthService
      localStorage.removeItem("isso_access_token");
      localStorage.removeItem("isso_refresh_token");
      localStorage.removeItem("isso_role");
      this.router.navigate(["/login"]);
    }
  }

  storageEvt() {
    // react to storage changes from other tabs
  }
}
